export const getImageFormat = (url?: string | false) => {
  if (!url || typeof url !== 'string') return 'image/png';

  const ext = url.split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'svg':
      return 'image/svg+xml';
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    default:
      return 'image/png';
  }
};
